import { Label } from "@/components/ui/label";
import { ReactNode } from "react";

export const FieldGroup = ({
	label,
	hint,
	children,
	action,
}: {
	label: string;
	hint?: string;
	children: ReactNode;
	action?: ReactNode;
}) => (
	<div className="space-y-1.5">
		<div className="flex items-start justify-between gap-2">
			<div>
				<Label className="text-sm font-medium">{label}</Label>
				{hint && <p className="text-xs text-muted-foreground mt-0.5">{hint}</p>}
			</div>
			{action}
		</div>
		{children}
	</div>
);
